"use client";

import { motion, useScroll, useTransform } from "framer-motion";
import { GraduationCap } from "lucide-react";
import { MagneticButton } from "./MagneticButton";

export function Header() {
  const { scrollY } = useScroll();
  const bg = useTransform(
    scrollY,
    [0, 80],
    ["rgba(255,255,255,0)", "rgba(255,255,255,0.85)"]
  );
  const blur = useTransform(scrollY, [0, 80], ["blur(0px)", "blur(14px)"]);
  const border = useTransform(
    scrollY,
    [0, 80],
    ["rgba(0,0,0,0)", "color-mix(in oklab, var(--navy) 10%, transparent)"]
  );

  return (
    <motion.header
      style={{ backgroundColor: bg, backdropFilter: blur, borderColor: border }}
      className="fixed inset-x-0 top-0 z-50 border-b"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-10">
        <a href="#top" className="flex items-center gap-2.5 group">
          <span className="grid h-10 w-10 place-items-center rounded-xl bg-navy text-primary-foreground transition-transform group-hover:rotate-[-6deg]">
            <GraduationCap className="h-5 w-5" strokeWidth={2.4} />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-lg font-extrabold tracking-tight text-navy">
              Atherton
            </span>
            <span className="font-serif-body text-[11px] italic text-muted-foreground">
              Academy · Est. 1998
            </span>
          </span>
        </a>

        <MagneticButton href="#enroll" size="md">
          Enroll Now
        </MagneticButton>
      </div>
    </motion.header>
  );
}
